var map = {
	"./biography-and-history.svg": 82,
	"./biography-and-memoir.svg": 83,
	"./career-and-success.svg": 84,
	"./communication-and-social-skills.svg": 85,
	"./corporate-culture.svg": 86,
	"./creativity.svg": 87,
	"./economics.svg": 88,
	"./education.svg": 89,
	"./entrepreneurship-and-small-business.svg": 90,
	"./health-and-fitness.svg": 91,
	"./management-and-leadership.svg": 92,
	"./marketing-and-sales.svg": 93,
	"./mindfulness-and-happiness.svg": 94,
	"./money-and-investments.svg": 95,
	"./motivation-and-inspiration.svg": 96,
	"./nature-and-environment.svg": 97,
	"./parenting.svg": 98,
	"./personal-growth-and-self-improvement.svg": 99,
	"./philosophy.svg": 100,
	"./politics-and-society.svg": 101,
	"./productivity-and-time-management.svg": 102,
	"./psychology.svg": 103,
	"./relationships-and-parenting.svg": 104,
	"./religion-and-spirituality.svg": 105,
	"./science.svg": 106,
	"./society-and-culture.svg": 107,
	"./technology-and-the-future.svg": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;